import React from 'react'
import './SignIn.css'
import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { deleteAllCard } from '../../redux/actions/productAction';




const SignIn = () => {
    const produitsDeCart = useSelector(state => state.PrduitsDeCart.produitsCard)
    const [supproduitsDeCart, setSupproduitsDeCart] = useState([])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [formData, setFormData] = useState({
        nom: '', 
        prenom: '',
        email: '',
        numero: '',
    })
    const {nom, prenom, email, numero} = formData;
    const change = (e) => {
        setFormData(prevState => ({
            ...prevState,
            [e.target.id]: e.target.value
        }))
    }
    const [showSingIn, setShowSignIn] = useState(false)


    const onSubmit = (e) => {
        e.preventDefault()
        if(nom === '' || prenom === '' || email === '' || numero === '') {
            toast.error('Veuillez remplir tous les champs', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        else {
            console.log(formData)
            setShowSignIn(prevState => !prevState)
            console.log(showSingIn)
            toast.success('Votre commande a été envoyé avec succès', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            // console.log(produitsDeCart)
            
            setTimeout(() => (dispatch(deleteAllCard()), navigate('/')), 2000);
            
        }
    }
    const fermer = () => {
        console.log('zz')
        setShowSignIn(prevState => !prevState)
        navigate('/')
    }
    
  return (
    <>
        <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
        />
        <div className="Inscription">
            <div className='InscriForm'>
                <div className='fermer' onClick={fermer}>
                    Fermer
                </div>
                <form onSubmit={onSubmit}>
                    <div>
                        <label htmlFor="name"> Nom </label>
                        <br />
                        <input type="text" id='nom' value={nom} onChange={change} placeholder="Entrer votre Nom"/>
                    </div>
                    <div>
                        <label htmlFor="prenom"> Prénom </label>
                        <br />
                        <input type="text" id='prenom' value={prenom} onChange={change} placeholder="Entrer votre Prénom"/>
                    </div>
                    <div>
                        <label htmlFor="email"> Email </label>
                        <br />
                        <input type="email" id='email' value={email} onChange={change} placeholder="Entrer votre Email"/>
                    </div>
                    <div>
                        <label htmlFor="numero"> Numéro de téléphone </label>
                        <br />
                        <input type="number" id='numero' value={numero} onChange={change} placeholder="Entrer votre Adresse"/>
                    </div>
                    <div>
                        <button type='submit'>
                            Envouyer
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </>
  )
}

export default SignIn